/**
 * VIP and Pro store product ids (plan section 5). Pure, so the subscription
 * hook can name a member's plan without loading RevenueCat;
 * services/nativeVipPro.ts re-exports all of it.
 */
export type NativeVipProTier = 'vip' | 'pro';
export type NativeVipProInterval = 'monthly' | 'annual';

/** App Store, subscription group 21112351. */
export const IOS_VIP_PRO_PRODUCT_IDS: Record<NativeVipProTier, Record<NativeVipProInterval, string>> = {
  vip: { monthly: 'jp_vip_monthly', annual: 'jp_vip_annual' },
  pro: { monthly: 'jp_pro_monthly', annual: 'jp_pro_annual' },
};
export const IOS_VIP_RESCUE_PRODUCT_ID = 'jp_vip_annual_rescue7';

/** Google Play subscriptions and base plans. */
export const ANDROID_VIP_PRO_PRODUCT_IDS: Record<NativeVipProTier, string> = {
  vip: 'jp_vip',
  pro: 'jp_pro',
};

/** VIP or Pro for a store product id on either platform; null for anything else (legacy included). */
export function nativeVipProTierForProductId(productId: string | null | undefined): NativeVipProTier | null {
  if (!productId) return null;
  // Play ids can carry the base plan ("jp_vip:annual").
  const colon = productId.indexOf(':');
  const bare = colon === -1 ? productId : productId.slice(0, colon);
  for (const tier of ['vip', 'pro'] as const) {
    if (bare === ANDROID_VIP_PRO_PRODUCT_IDS[tier]) return tier;
    if (Object.values(IOS_VIP_PRO_PRODUCT_IDS[tier]).includes(productId)) return tier;
  }
  if (productId === IOS_VIP_RESCUE_PRODUCT_ID) return 'vip';
  return null;
}
